import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Thermometer } from 'lucide-react';
import { getHaccpTemperatureLocations } from './useHaccpConfigurations';

export default function HaccpTemperatureShortcut({ disabled = false }) {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    let active = true;
    if (!disabled) getHaccpTemperatureLocations()
      .then((result) => { if (active) setAvailable(Array.isArray(result?.locations) && result.locations.length > 0); })
      .catch(() => { if (active) setAvailable(false); });
    return () => { active = false; };
  }, [disabled]);
  if (disabled || !available) return null;
  return (
    <Link to="/haccp/temperature" className="flex min-h-14 items-center gap-3 rounded-2xl border border-emerald-200 bg-white p-4 text-brand-navy" data-testid="employee-haccp-temperature">
      <Thermometer className="h-5 w-5 text-brand-green" aria-hidden="true" />
      <span><strong className="block text-sm">Temperature HACCP</strong><small className="text-stone-500">Foto, verifica e controlli del locale</small></span>
    </Link>
  );
}
